import React, { FC } from "react";
import { Box, GridSize } from "@mui/system";
import { Grid2Props } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";

interface Props extends Grid2Props {
  itemColumns?: {
    xl?: GridSize;
    lg?: GridSize;
    md?: GridSize;
    sm?: GridSize;
    xs?: GridSize;
  };
}

const EvenGrid: FC<Props> = (props) => {
  const { itemColumns, spacing, children } = props;

  const childArray =
    (children as React.ReactNode[]).length !== undefined
      ? (children as React.ReactNode[])
      : [children as React.ReactElement];

  return (
    <Grid2 container {...props}>
      {childArray.map((child, i) => (
        <Grid2 key={i} {...itemColumns}>
          <Box sx={{ position: "relative", paddingBottom: "80%" }}>
            <Box
              sx={{
                borderRadius: 1.5,
                overflow: "hidden",
                height: "100%",
                width: "100%",
                position: "absolute",
                minHeight: "104px",
                top: 0,
              }}
            >
              {child}
            </Box>
          </Box>
        </Grid2>
      ))}
    </Grid2>
  );
};

export default EvenGrid;
